import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Alert, { type AlertAction } from '/@/components/bayer/alert';
import useUnitProvider from '/@/core/context/unit';
import { _ } from '/@/locale';

/**
 * The footnote under the density cards: the achievement percentage the seed figures assume,
 * and the surface the bag totals were computed over.
 *
 * Shared by the wizard's management step and the result page so the two can't drift, and so
 * the hectares→display-unit conversion lives in one place — the same reason
 * `areaInHectaresFrom` is shared. The surface sentence is dropped when there's no area,
 * since the cards then show no bag totals to explain.
 */
function DensityCaption({
    planterEfficiency,
    areaInHectares,
    actions,
}: {
    planterEfficiency: number;
    /** Hectares, as `useManagementData` reports it; converted here for display. */
    areaInHectares?: number;
    actions?: AlertAction[];
}) {
    const units = useUnitProvider();
    const area = areaInHectares !== undefined ? units.toArea(areaInHectares, 2) : undefined;

    const sentences = [
        _('Densidad calculada con {{value}}% de logro.', {
            value: planterEfficiency,
        }),
        area && _('Bolsas con {{value}} a sembrar.', { value: area.toString() }),
    ].filter(Boolean);

    return (
        <Alert
            severity='surface'
            icon={<InfoOutlinedIcon sx={{ fontSize: 18, color: (theme) => theme.palette.primary.main }} />}
            actions={actions}
        >
            {sentences.join(' ')}
        </Alert>
    );
}

export default DensityCaption;
